import { Marca } from '../design-system/Marca';

type Acao = { rotulo: string; executar: () => void };

/** Página simples de aviso (carregando, sem acesso ao quadro, sem quadros). */
export function TelaAviso({ titulo, texto, acoes = [] }: { titulo: string; texto?: string; acoes?: Acao[] }) {
  return (
    <main className="tela-acesso">
      <section className="cartao-acesso cartao-acesso--aviso" aria-live="polite">
        <Marca tamanho={40} />
        <h1>{titulo}</h1>
        {texto && <p className="cartao-acesso__subtitulo">{texto}</p>}
        {acoes.map((acao) => (
          <button key={acao.rotulo} type="button" className="botao-primario cartao-acesso__botao" onClick={acao.executar}>
            {acao.rotulo}
          </button>
        ))}
      </section>
    </main>
  );
}
